<template>
    <div class="w-100 h-100 d-flex flex-column">
        <layout-configuration-title ref="layoutConfig" class="w-100" :module-code="service"
                                    identify-code="query-config"
                                    empty-config-title="空白配置"
                                    :single-mode="singleMode"
                                    no-auto-gather
                                    @loadConfig="unpackConfig"
                                    @submitted="$emit('saved')">
            <div class="d-flex flex-row">
                <IdRecode v-if="id && !singleMode" class="mr-1" :id="id" :service="service"/>
                <view-i18n ref="viewI18n" :items="activeSelects" class="ml-1"></view-i18n>
                <form-config ref="formConfig" :items="activeSelects" class="ml-1"
                             @change="noticeChange"></form-config>
                <b-button class="ml-1" variant="outline-secondary" @click="preview">
                    <i class="fa-solid fa-eye"></i>
                </b-button>
            </div>
        </layout-configuration-title>

        <sql-config ref="voConfig" @activeSelects="activeSelects=$event"></sql-config>

        <query-view-modal ref="qvm" header="Preview" :use-config-id="id" enable-query-input
                          enableExport></query-view-modal>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import LayoutConfigurationTitle from "@/components/common/mini-table/cells/LayoutConfigurationTitle.vue";
import ViewI18n from "@/components/jsc/qc-cell/stuff/ViewI18n.vue";
import FormConfig from "@/components/jsc/qc-cell/stuff/FormConfig.vue";
import IdRecode from "@/components/jsc/qc-cell/stuff/IdRecode.vue";
import SqlConfig from "@/components/jsc/qc-cell/SqlConfig.vue";
import QueryViewModal from "@/components/common/display/query-view/QueryViewModal.vue";

export default {
    name: "QueryConfig",
    components: {
        QueryViewModal,
        SqlConfig,
        IdRecode,
        FormConfig,
        ViewI18n,
        LayoutConfigurationTitle
    },
    mixins: [emCommonUtilMixin],
    props: {
        singleMode: Boolean,
    },
    data() {
        return {
            id: null,
            activeSelects: [],
            refreshFlag: new Date(),
        }
    },
    computed: {
        service() {
            return this.$store.state.queryConfigStore.currentService;
        },
        currentConfig() {
            if (this.refreshFlag) {
                //
            }
            return this.gatherConfig();
        },
    },
    watch: {
        currentConfig: {
            handler() {
                let el = this.$refs.layoutConfig;
                if (el) {
                    el.currentConfigurationObject = this.currentConfig;
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        // this.openServiceInput();
    },
    methods: {
        getOtherConfigEl() {
            return [
                this.getRefEl('viewI18n'),
                this.getRefEl('formConfig')
            ]
        },
        //----------------------------------------------------------------
        gatherConfig() {
            if (!this.service) {
                return null;
            }
            let result = this.$refs.voConfig.gatherConfig();
            if (result != null) {
                let oc = this.getOtherConfigEl();
                for (let el of oc) {
                    let config = el.gatherConfig();
                    this.copyObj2Obj(config, result, true);
                }
            }
            return result;
        },
        unpackConfig(config) {
            this.$refs.voConfig.unpackConfig(config);
            if (!config) {
                this.id = null;
                //unpack others
                let oc = this.getOtherConfigEl();
                for (let el of oc) {
                    el.unpackConfig(null);
                }
            } else {
                this.id = config.id;
                let all = JSON.parse(config.configuration);
                //unpack others
                let oc = this.getOtherConfigEl();
                for (let el of oc) {
                    el.unpackConfig(all);
                }
            }
        },
        noticeChange() {
            // this.$refs.layoutConfig.configChanged();
            this.refreshFlag = new Date();
        },
        //----------------------------------------------------------------
        load(item) {
            this.$nextTick(() => {
                this.$refs.layoutConfig.loadConfig(item);
            })
        },
        //----------------------------------------------------------------
        preview() {
            this.$refs.qvm.showModal();
        },
        //----------------------------------------------------------------
    }
}
</script>

<style scoped>

</style>
